import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormManager, FormRow, Grid, PageTitle, useCacheQuery, useCloneEntity } from 'gossamer-front-end';
import { InstitutionGroup, InstitutionGroupAdmin, InstitutionGroupAdminRow } from 'cb-model';
import { getFilter, getListRowLink, ReferenceField } from 'gossamer-unified';

export const GroupAdminsGrid = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();

  const query = useCacheQuery(InstitutionGroupAdmin, {
    where: { and: [getFilter('institution_group_id', 'eq', params.key)] },
  });

  const InstitutionGroupAdminLocal = useCloneEntity(InstitutionGroupAdmin, (local) => {
    local.fields.institution_group_id.listColumn = false;
    (local.fields.user_id as ReferenceField).refFilters = [
      { fieldId: 'institution_id', operator: 'eq', value: params.key, display: 'no-edit' },
    ];
  });

  const handleExit = () => navigate(getListRowLink(InstitutionGroup.listRowLink, params.key));

  return (
    <>
      <PageTitle verb="Update" entity={InstitutionGroupAdmin} keyValue={params.key} />
      <FormManager
        compoundUrl="/main/~/institution-group-admins-grid"
        handleCancel={handleExit}
        handleSuccess={handleExit}
        initialization={{
          main: {
            type: 'update-multi',
            entity: InstitutionGroupAdmin,
            query,
          },
        }}
      >
        <Grid
          valuesKey="main"
          entity={InstitutionGroupAdminLocal}
          addRowFieldId="user_id"
          onAddRow={(data: FormRow<InstitutionGroupAdminRow>, newValue: string) => {
            data.institution_group_id = parseInt(params.key, 10);
            data.user_id = newValue;
          }}
        />
      </FormManager>
    </>
  );
};
